(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Products that require a choice (variants / bundles / subscriptions) must not
  // open the quick-add dialog. The button element itself is left untouched so the
  // theme's layout and styling are unaffected — only its dialog-invoker attributes
  // are stripped, and a plain navigation handler is bound in their place.
  (() => {
    const QUICK_ADD_SELECTOR = [
      'quick-add-component button',
      '.quick-add__button',
      '.quick-add button',
      '[data-quick-add]',
      'add-to-cart-component button',
      'product-form-component button[type="submit"]',
    ].join(', ');

    const INVOKER_ATTRIBUTES = [
      'on:click',
      'command',
      'commandfor',
      'commandForElement',
      'popovertarget',
      'popovertargetaction',
      'aria-haspopup',
      'aria-controls',
    ];

    const disarm = (root) => {
      if (!root || !root.querySelectorAll) return;

      const cards =
        root.matches && root.matches('[data-force-pdp="true"]')
          ? [root]
          : root.querySelectorAll('[data-force-pdp="true"]');

      cards.forEach((card) => {
        const productUrl = card.dataset.productUrl;
        if (!productUrl) return;

        card.querySelectorAll(QUICK_ADD_SELECTOR).forEach((button) => {
          if (button.dataset.pdpRedirect === 'true') return;

          INVOKER_ATTRIBUTES.forEach((attribute) => button.removeAttribute(attribute));
          button.setAttribute('type', 'button');
          button.dataset.pdpRedirect = 'true';

          button.addEventListener(
            'click',
            (event) => {
              event.preventDefault();
              event.stopPropagation();
              event.stopImmediatePropagation();
              window.location.href = productUrl;
            },
            true
          );
        });
      });
    };

    const init = () => {
      disarm(document);

      // Re-apply for cards injected by infinite scroll, filtering, or section re-render.
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) disarm(node);
          });
        });
      });

      document.querySelectorAll('results-list').forEach((list) => {
        observer.observe(list, { childList: true, subtree: true });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
